function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import urlParse from '@collaborator/npm_modules/dist/helpers/url/urlParse';

var ScrollToBlock = /*#__PURE__*/function () {
  function ScrollToBlock() {
    _classCallCheck(this, ScrollToBlock);
  }

  _createClass(ScrollToBlock, null, [{
    key: "init",
    value: function init() {
      this.processQuery();
      document.addEventListener('click', this.handlerClick);
    }
  }, {
    key: "scrollToIfTopIsNotViewport",
    value: function scrollToIfTopIsNotViewport(target) {
      if (window.pageYOffset > target.getBoundingClientRect().top) {
        ScrollToBlock.scrollTo(target);
      }
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(target) {
      if (!target) {
        return;
      }

      target.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  }, {
    key: "processQuery",
    value: function processQuery() {
      var _urlParse = urlParse(window.location.search),
          query = _urlParse.query;

      if ('scrollTo' in query) {
        ScrollToBlock.scrollTo(document.getElementById(query.scrollTo));
      }
    }
  }, {
    key: "handlerClick",
    value: function handlerClick(e) {
      var target = e.target;

      if (!target.classList.contains('scroll-to-element')) {
        return;
      }

      var destination = document.getElementById(urlParse(target.href).query.scrollTo);

      if (!destination) {
        return;
      }

      e.preventDefault();
      ScrollToBlock.scrollTo(destination);
    }
  }]);

  return ScrollToBlock;
}();

export default ScrollToBlock;